export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;

export const KEY = 'c71ddfea-36df-4672-9431-ae33196a1092';

export const MODAL_CLOSE_SEC = 2.5;
